import React, { useRef } from "react";
import { Card } from "../ui/card";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ProductCard = ({ product, delay = 0 }) => {
  const sliderRef = useRef(null);

  const scroll = (dir) => {
    sliderRef.current?.scrollBy({
      left: dir === "left" ? -260 : 260,
      behavior: "smooth",
    });
  };

  return (
    <Card
      className="p-4 transition-all border shadow-sm group sm:p-5 rounded-3xl border-border bg-card/90 hover:shadow-lg"
      style={{ transitionDelay: `${delay}ms` }}
    >
      {/* TOP INFO */}
      <div className="flex flex-col gap-4 sm:flex-row">
        {/* IMAGE UTAMA (Tetap 4:3 sesuai kode asli) */}
        <div className="w-full sm:w-28 aspect-[4/3] overflow-hidden rounded-2xl bg-secondary shrink-0">
          <img
            src={product.imageUrl}
            alt={product.name}
            className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-[1.03]"
            loading="lazy"
          />
        </div>

        {/* TEXT */}
        <div className="flex-1">
          <p className="text-[10px] font-medium tracking-[0.2em] uppercase text-primary">
            Signature Series
          </p>
          <h3 className="mt-1 text-sm font-semibold text-foreground">
            {product.name}
          </h3>
          <p className="mt-1 text-xs text-muted-foreground line-clamp-2">
            {product.shortDescription}
          </p>

          {/* META */}
          <div className="flex flex-wrap gap-2 mt-3 text-[11px]">
            <span className="px-3 py-1 rounded-full bg-secondary">
              🌶 {product.generalInfo.spiceLevel}
            </span>
            <span className="px-3 py-1 rounded-full bg-secondary">
              ⏱ {product.generalInfo.prepTime}
            </span>
          </div>
        </div>
      </div>

      {/* HIGHLIGHTS */}
      <ul className="flex flex-wrap gap-2 mt-4 text-[11px] text-muted-foreground">
        {product.highlights.map((item) => (
          <li key={item} className="px-3 py-1 rounded-full bg-secondary/80">
            {item}
          </li>
        ))}
      </ul>

      {/* SHOWCASE SLIDER */}
      <div className="mt-6">
        <div className="flex items-center justify-between mb-2">
          <p className="text-xs font-semibold text-foreground">
            Contoh olahan favorit
          </p>

          {/* DESKTOP NAV ONLY */}
          <div className="hidden gap-1 sm:flex">
            <button
              onClick={() => scroll("left")}
              className="flex items-center justify-center rounded-full w-7 h-7 bg-secondary hover:bg-secondary/80"
            >
              <ChevronLeft size={14} />
            </button>
            <button
              onClick={() => scroll("right")}
              className="flex items-center justify-center rounded-full w-7 h-7 bg-secondary hover:bg-secondary/80"
            >
              <ChevronRight size={14} />
            </button>
          </div>
        </div>

        <div
          ref={sliderRef}
          className="flex gap-3 overflow-x-auto scroll-smooth snap-x snap-mandatory no-scrollbar"
        >
          {product.variants.map((menu) => (
            <div
              key={menu.id}
              className="relative min-w-[80%] sm:min-w-[200px] snap-start overflow-hidden rounded-2xl bg-secondary"
            >
              {/* PERBAIKAN DI SINI: Menggunakan aspect-[4/5] menggantikan h-36 */}
              <img
                src={menu.imageUrl}
                alt={menu.name}
                className="object-cover w-full aspect-[4/5]"
                loading="lazy"
              />

              {/* OVERLAY */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

              {/* CAPTION */}
              <div className="absolute bottom-0 p-3">
                <p className="text-xs font-semibold text-white">{menu.name}</p>
                <p className="text-[11px] text-white/90 line-clamp-2">
                  {menu.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default ProductCard;
